module.exports = __webpack_public_path__ + "img/lineChart.6ed78456.svg";